import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import * as Clipboard from 'expo-clipboard';
import { Copy } from 'lucide-react-native';
import { memo, useCallback } from 'react';
import { Pressable } from 'react-native';
import Toast from 'react-native-root-toast';
import { BiTableModel, biTableTsv } from './functions/biResultTable';

/**
 * 复制数据: the table as tab-separated values as stored (a rate 0.5, money
 * in cents), every row, so a spreadsheet gets the numbers themselves.
 */
export function copyBiTable(table: BiTableModel): void {
  Clipboard.setStringAsync(biTableTsv(table)).then(
    () =>
      Toast.show('已复制原始数据', {
        duration: 800,
        position: Toast.positions.CENTER,
      }),
    error => console.error('copying a BI table failed', error),
  );
}

/**
 * The 复制数据 button. Floating over a scrolling table it takes a box of
 * its own, so the rows under it do not show through.
 */
export const CopyTableButton = memo(
  ({ table, floating }: { table: BiTableModel; floating?: boolean }) => {
    const { rpx } = useResponsiveContext();
    const copy = useCallback(() => copyBiTable(table), [table]);
    return (
      <Pressable
        accessibilityRole="button"
        accessibilityLabel="复制数据"
        onPress={copy}
        hitSlop={8}
        style={({ pressed }) => ({
          flexDirection: 'row',
          alignItems: 'center',
          gap: rpx(4),
          opacity: pressed ? 0.6 : 1,
          ...(floating
            ? {
                paddingHorizontal: rpx(10),
                paddingVertical: rpx(5),
                borderRadius: rpx(14),
                borderWidth: 1,
                borderColor: aiColors.border,
                backgroundColor: aiColors.card,
                shadowColor: '#0F172A',
                shadowOpacity: 0.08,
                shadowRadius: 6,
                shadowOffset: { width: 0, height: 2 },
                elevation: 2,
              }
            : null),
        })}
      >
        <Copy size={12} color={aiColors.mutedForeground} />
        <Typography.Text size={rpx(11)} color={aiColors.mutedForeground}>
          复制数据
        </Typography.Text>
      </Pressable>
    );
  },
);
